import React, { useEffect, useState } from 'react';

function ActiveDownloads() {
  const [downloads, setDownloads] = useState([]);
  const [connected, setConnected] = useState(false);

  useEffect(() => {
    // Fetch initial active downloads
    fetchActiveDownloads();
    
    // Setup SSE connection for real-time updates
    const eventSource = new EventSource('/api/downloads/progress', {
      withCredentials: true
    });
    
    eventSource.onopen = () => {
      setConnected(true);
    };
    
    eventSource.onmessage = (event) => {
      const data = JSON.parse(event.data);
      
      if (data.type === 'initial') {
        setDownloads(data.downloads || []);
      } else if (data.type === 'progress') {
        setDownloads(prev => {
          const existing = prev.find(d => d.id === data.id);
          if (existing) {
            return prev.map(d => d.id === data.id ? { ...d, ...data } : d);
          } else {
            return [...prev, data];
          }
        });
      } else if (data.type === 'complete') {
        setDownloads(prev => prev.filter(d => d.id !== data.id));
      } else if (data.type === 'error') {
        setDownloads(prev => prev.map(d => 
          d.id === data.id ? { ...d, status: 'error', error: data.error } : d
        ));
      }
    };
    
    eventSource.onerror = () => {
      setConnected(false);
    };
    
    return () => {
      eventSource.close();
    };
  }, []);

  const fetchActiveDownloads = async () => {
    try {
      const response = await fetch('/api/downloads/active', {
        credentials: 'include'
      });
      if (response.ok) {
        const data = await response.json();
        setDownloads(data);
      }
    } catch (err) {
      console.error('Failed to fetch active downloads:', err);
    }
  };

  if (downloads.length === 0) {
    return null;
  }

  return (
    <section className="active-downloads-section">
      <div className="section-header">
        <h2>Downloading</h2>
        <span className="number">{String(downloads.length).padStart(2, '0')}</span>
        <span className={`connection-status ${connected ? 'connected' : 'disconnected'}`}>
          {connected ? '● Live' : '○ Offline'}
        </span>
      </div>
      
      <div className="active-downloads-list">
        {downloads.map((download) => (
          <div key={download.id} className={`active-download-item ${download.status}`}>
            <div className="download-info">
              <h4 className="download-title">{download.title}</h4>
              <div className="download-meta">
                <span className="download-quality">{download.quality}</span>
                {download.audio_only && <span className="audio-badge">Audio</span>}
                {download.speed && (
                  <span className="download-speed">{download.speed}</span>
                )}
                {download.eta && download.status === 'downloading' && (
                  <span className="download-eta">ETA {download.eta}</span>
                )}
              </div>
            </div>
            
            <div className="progress-container">
              <div className="progress-bar">
                <div 
                  className="progress-fill"
                  style={{ width: `${download.progress || 0}%` }}
                />
              </div>
              <span className="progress-text">
                {download.status === 'error' ? 'Error' : `${Math.round(download.progress || 0)}%`}
              </span>
            </div>
            
            {download.error_message && (
              <div className="error-message small">{download.error_message}</div>
            )}
          </div>
        ))}
      </div>
    </section>
  );
}

export default ActiveDownloads;